import * as React from 'react';
import {connect} from 'react-redux';

import {Routing} from 'nutshell-core/routing';

import {SelectableListMultiple} from 'shells/selectable-list/selectable-list';

import type {NutshellState} from '../../../../../../store';
// @ts-expect-error
import * as dashboardSelectors from '../../../../dashboard-selectors';

import styles from './listsummaries-form.module.css';

const MAX_LISTS = 6;

type OwnProps = {
    value: string;
    updateValue: (newValue: string) => void;
    onCustomError: (errorMessage: string | React.ReactElement<any>) => void;
    onCustomErrorCleared: () => void;
    submitFailed: boolean | null | undefined;
};
type StateProps = {
    savedLists: any[];
};
type Props = OwnProps & StateProps;

const mapStateToProps = function (state: NutshellState) {
    return {
        savedLists: dashboardSelectors.getSavedLists(state),
    };
};

export class ListsummariesFormComponent extends React.Component<Props> {
    render() {
        const {savedLists} = this.props;
        const formValues = Routing.deparam(this.props.value);
        const selectedListIds = formValues.listIds ? formValues.listIds.split(',') : [];

        return (
            <div className={styles.container}>
                <div className={styles['label-container']}>
                    <h3
                        className={
                            this.props.submitFailed
                                ? styles['required-label--invalid']
                                : styles['required-label']
                        }
                    >
                        Saved lists
                    </h3>
                    <span>{`${selectedListIds.length} / ${MAX_LISTS} added`}</span>
                </div>
                <div className={styles['list-container']}>
                    {/* @ts-expect-error */}
                    <SelectableListMultiple
                        value={selectedListIds}
                        collection={savedLists}
                        onSelect={this.handleChange}
                    />
                </div>
            </div>
        );
    }

    handleChange = (listIds: string[]) => {
        if (listIds.length > MAX_LISTS) {
            this.props.onCustomError(
                <div>
                    <span>You can only add 6 summary lists per card.</span>
                    <br />
                    <span>If you’d like to add more, create a new card.</span>
                </div>
            );
        } else {
            this.props.onCustomErrorCleared();
            const newListIds = listIds.join(',');
            if (newListIds) {
                this.props.updateValue(`listIds=${newListIds}`);
            } else {
                this.props.updateValue('');
            }
        }
    };
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps);
export const ListsummariesForm = connector(ListsummariesFormComponent);
